import { Component } from "./component.js";
class MediaZoom extends Component {
  connectedCallback() {
    (super.connectedCallback(), this.#e());
  }
  #e() {
    (this.refs.closeBtn instanceof HTMLButtonElement &&
      this.refs.closeBtn.addEventListener("click", () => this.close()),
      this.refs.backdrop instanceof HTMLElement &&
        this.refs.backdrop.addEventListener("click", () => this.close()),
      document.addEventListener("keydown", (e) => {
        "Escape" === e.key &&
          this.classList.contains("is-active") &&
          this.close();
      }),
      document.addEventListener("media:zoom:open", (e) => {
        const { type: s, src: t, alt: o } = e.detail;
        this.open(s, t, o);
      }));
  }
  open(e, s, t) {
    const o = this.refs.zoomedImage,
      i = this.refs.zoomedVideo;
    ("image" === e
      ? ((o.src = s),
        (o.alt = t || ""),
        (o.style.display = "block"),
        (i.style.display = "none"),
        i.pause())
      : "video" === e &&
        ((i.src = s),
        (i.style.display = "block"),
        (o.style.display = "none"),
        i.play()),
      this.classList.add("is-active"),
      (document.body.style.overflow = "hidden"));
  }
  close() {
    const e = this.refs.zoomedImage,
      s = this.refs.zoomedVideo;
    (this.classList.remove("is-active"),
      (document.body.style.overflow = ""),
      s.pause(),
      (s.src = ""),
      (e.src = ""));
  }
}
customElements.get("media-zoom") ||
  customElements.define("media-zoom", MediaZoom);
